import React from "react";
import { store, action, useDsp, useSlc, RootState } from "app/store";
import { apiWishDelete } from "app/api";
import { Button } from "components/button";
import { useNavigate } from "react-router-dom";

export const WrapperWishDelete = () => {
  const dispatch = useDsp();
  const navigate = useNavigate();

  const uuid = useSlc((state: RootState) => state.mWishRemove);

  const apiSuccsess = ({ status }: any, uuid: string) => {
    // console.log("API REMOVE WISH SUCCESS");
    if (status === 204) {
      dispatch(action.mWishRemoveSet(""));
      const currWishes = store
        .getState()
        .dataProfileWishes.filter((w: any) => w.uuid !== uuid);
      dispatch(action.dataProfileWishesSet(currWishes));
      navigate("/profile/wishes");
    }
  };

  const apiError = (err: any) => {
    // console.log("API REMOVE WISH SUCCESS", err);
  };

  return (
    <div className="row mt-2">
      <div className="d-flex">
        <Button
          type="button"
          onClick={() =>
            apiWishDelete(
              uuid,
              (data: any) => apiSuccsess(data, uuid),
              apiError
            )
          }
        >
          Подтвердить
        </Button>
        <Button
          type="button"
          white
          onClick={() => dispatch(action.mWishRemoveSet(""))}
        >
          Отменить
        </Button>
      </div>
    </div>
  );
};
